import { gql } from '@apollo/client'

const retailQuery = `
airPriceGuide(input: $input) {
  error {
    type
    code
    message
  }
  total
  viewers
  records {
    viewers
    destinations {
      airportCode
      cityCode
      stateCode
      countryCode
    }
    origins {
      airportCode
      cityCode
      stateCode
      countryCode
    }
    displayContent {
      displayPrice
      displayDate
    }
    dates
    cabinClass
    paxChild
    paxInfant
    paxAdult
    isSuperSearchItin
    isSuperSearchBotItin
    isFirefly
    currencyCode
    minimumFare {
      isPrivateFare
      currency
      validatingCarrier
      amtPerPax
      currencySymbol
      commonAttributes {
        takeOffTimes
        landingTimes
      }
      listOfStops {
        sliceId
        stops
      }
    }
  }
}
`

const airPriceGuideExpressDealOW = `
  query airPriceGuideExpressDealOW($input:AirPriceGuideRequest) {
    ${retailQuery}
  }
`

const airPriceGuideRetailOW = `
  query airPriceGuideRetailOW($input:AirPriceGuideRequest) {
    ${retailQuery}
  }
`

const airPriceGuideExpressDealRT = `
  query airPriceGuideExpressDealRT($input:AirPriceGuideRequest) {
    ${retailQuery}
  }
`

const airPriceGuideRetailRT = `
  query airPriceGuideRetailRT($input:AirPriceGuideRequest) {
    ${retailQuery}
  }
`

const airPriceGuideNumViewers = `
  query airPriceGuideNumViewers($input:AirPriceGuideRequest) {
    airPriceGuide(input: $input) {
      viewers
    }
  }
`

const apolloClientAirPriceGuideNumViewers = gql`
  query apolloClientAirPriceGuideNumViewers($input: AirPriceGuideRequest) {
    airPriceGuide(input: $input) {
      viewers
    }
  }
`

const airPriceGuideRequests = {
  airPriceGuideExpressDealOW,
  airPriceGuideRetailOW,
  airPriceGuideExpressDealRT,
  airPriceGuideRetailRT,
  airPriceGuideNumViewers,
  apolloClientAirPriceGuideNumViewers,
}

export default airPriceGuideRequests